<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2bBOAX/tc-custom/9781955518116.jpg?1707451208743" alt="This image is the cover for the book Corruption, NEON"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Corruption, NEON
      </h1>
      <p class="bookDescription body article font2">
        <b>Dahlia</b><br/><br/>For the first time in my life, I know where I came from, and I can embrace my heritage.<br/><br/>But the price on my head has grown, and those closest to me are in danger as well.<br/><br/><b>Freyr will never forgive me if something happens to Fenrir.</b> I don't blame him--I won't be able to forgive myself if I lose either of them.<br/><br/><b>Author's Note:</b>This series will give you multiple happily ever afters, for multiple MMF polyamorous triads… But getting there will be one hell of an angst-filled ride.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Allyson Lindt
      </h2>
      
      <p class="authorDescription body article"><b><i>USA Today Bestselling Author</i></b> Allyson Lindt is a full-time geek and a fuller-time author. She likes her stories with sweet geekiness and heavy spice, and loves a sexy happily-ever-after. Because cubicle dwellers need love too.<br><br>Her #GeekLove Contemporary and Ménage Romance books all take place in the same contemporary world. While each series stands on its own, readers' favorite characters, businesses, and places make appearances in other series.<br><br>You can connect with Allyson at her website:<b> http://www.allysonlindt.co/</b> <br><br>Read all of her books to see why <i>A Lust for Reading</i> said her books made them <b>"smile and literally laugh out loud"</b>, <i>Revenge of the Feels</i> loved the <b>sizzling attraction, ...danger, betrayal and humor"</b> and readers call them <b>"book nirvana"</b>,<b>"geek hotness"</b>, <b>"sexy"</b> and <b>"fast paced"</b>.<br><br>In addition to her contemporary romance series - <b><i>Love Games</i></b>, <b><i>Love Hack</i></b>, and <b><i>Game for Cookies</i> (formerly <i>For the Win</i>)</b> Allyson has written <b><i>Hacking Wonderland</i></b> (romantic suspense) and... <br><br><b><i>Truth's Harem</i></b> (reverse harem, fantasy romance)<br>1. Fate's Illusion<br>2. Innovations Muse<br>3.Apathy's Hero<br><br><b><i>Ridden Hard</i></b> (contemporary romance)<br>1. Hard Flip<br>2. Hard Pack<br>3. Riding the Wave<br><br><b><i>Subscribe, Live, Love</i></b> (fairy tale ménage romance)<br>1. Red Hunted<br>2. Red Consumed <br>3. Beauty Claimed<br>4. Beauty Awakened<br><br><b><i>The Love Equation</i> (formerly <i>Your Ad Here</i>)</b>, contemporary ménage romance)<br>1.The Rival and the Billionaire <br>2.The Geeks and the Socialite<br>3. The Second Chance and the Auctioneer<br>4. The Virgin and the Kingpin<br><br><b><i>Ubiquity</i></b> (urban fantasy)<br>1.Soul Reaper<br>2. Soul Betrayal<br><br>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Acelette Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7fa785bf